import { createSelector } from "reselect";

import { PersonalSettingsSpacesGroup, PersonalSettingsSpacesTableGroupsStore } from "./types";
import { isSpaceActionsGroup } from "../helpers";

export const selectTableRows = createSelector(
  (state: PersonalSettingsSpacesTableGroupsStore) => state.groups,
  (state: PersonalSettingsSpacesTableGroupsStore) => state.groupsMeta,
  (groups, groupsMeta): PersonalSettingsSpacesGroup[] => {
    const tableRows: PersonalSettingsSpacesGroup[] = [];

    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];
      const isGroupOpen = isSpaceActionsGroup(group) ? groupsMeta[group.spaceID]?.isOpen : false;

      tableRows.push(group);

      if (isGroupOpen) {
        const itemsIds = isSpaceActionsGroup(group) ? group.actions : [];

        if (itemsIds?.length) {
          itemsIds.forEach((itemId) => tableRows.push(itemId));
        }
      }
    }

    return tableRows;
  }
);

const selectTableRowsMap = createSelector(
  selectTableRows,
  (tableRows): Map<number, PersonalSettingsSpacesGroup> => {
    const map = new Map();
    for (let i = 0; i < tableRows.length; i++) {
      map.set(i, tableRows[i]);
    }
    return map;
  }
);

export const selectTableRowByIndex = createSelector(
  selectTableRowsMap,
  (_, index: number) => index,
  (tableRowsMap, index: number): PersonalSettingsSpacesGroup => {
    return tableRowsMap.get(index);
  }
);
